import { AthenaSiteNameEnums } from '@nf/types/site';

const generalProtectedPaths = [
	'/account',
	'/bets',
	'/favorites',
	'/results'
];

export const siteSettings = {
	ignoredCheckPaths: [
		'/deeplink'
	],
	protectedPaths: {
		before: [
			...generalProtectedPaths,
			'/message',
		],
		notDeposit: generalProtectedPaths
	},
};

/** only for athena site dev env. */
export const athenaSiteMapping: { [key: string]: AthenaSiteNameEnums } = {
	'4240700': AthenaSiteNameEnums['12B'],
	'4206300': AthenaSiteNameEnums['9Bet'],
	'4202100': AthenaSiteNameEnums.Aoncash,
	'4202600': AthenaSiteNameEnums.Athena000,
	'4215600': AthenaSiteNameEnums.Bolanation,
	'4202400': AthenaSiteNameEnums.ITCBet,
	'4209400': AthenaSiteNameEnums.M8bola,
	'4201800': AthenaSiteNameEnums.Macaubet,
	'4210200': AthenaSiteNameEnums.Q8bola,
	'4245600': AthenaSiteNameEnums.SabaDemo,
	'4200800': AthenaSiteNameEnums.Spondemo
};